import { IconLoader } from '@ui/src';
import Filters from './filters';
import NotificationItem from './notification';
import { MainColumnTypes } from './types';

import cn from './styles.module.css';

const NotificationCenterMainColumn = ({
  setPanelIsVisible,
  selectedCategories,
  setSelectedCategories,
  selectedGroups,
  setSelectedGroups,
  selectedActions,
  setSelectedActions,
  onCategoryFilterApply,
  onCategoryFilterClear,
  selectedStatuses,
  setSelectedStatuses,
  selectedExecutorId,
  setSelectedExecutorId,
  employees,
  notifications,
  selectedNotifications,
  selectedNotificationId,
  setSelectedNotification,
  categories,
  groups,
  types,
  selectedCategory,
  setSelectedCategory,
  selectedGroup,
  setSelectedGroup,
  categoryFilterTitle,
  withoutCategoryBackButton,
  setSelectedNotifications,
  isLoading,
  onApplyStatusFilter,
  onClearStatusFilter,
  onApplyExecutorFilter,
  onClearExecutorFilter,
  deadlineFilter,
  setDeadlineFilter,
  onClearDeadlineFilter,
  isFetching,
  filterFields,
  scrollRef,
  onScroll,
  nextPageIsLoading,
}: MainColumnTypes) => {
  let content;

  if (isLoading) {
    content = (
      <div className={cn.loader}>
        <IconLoader />
      </div>
    );
  } else {
    content = (
      <>
        <Filters
          setPanelIsVisible={setPanelIsVisible}
          selectedCategories={selectedCategories}
          setSelectedCategories={setSelectedCategories}
          selectedGroups={selectedGroups}
          setSelectedGroups={setSelectedGroups}
          selectedActions={selectedActions}
          setSelectedActions={setSelectedActions}
          onCategoryFilterApply={onCategoryFilterApply}
          onCategoryFilterClear={onCategoryFilterClear}
          selectedStatuses={selectedStatuses}
          setSelectedStatuses={setSelectedStatuses}
          selectedExecutorId={selectedExecutorId}
          employees={employees}
          setSelectedExecutorId={setSelectedExecutorId}
          categories={categories}
          groups={groups}
          types={types}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          selectedGroup={selectedGroup}
          setSelectedGroup={setSelectedGroup}
          categoryFilterTitle={categoryFilterTitle}
          withoutCategoryBackButton={withoutCategoryBackButton}
          onApplyStatusFilter={onApplyStatusFilter}
          onClearStatusFilter={onClearStatusFilter}
          onApplyExecutorFilter={onApplyExecutorFilter}
          onClearExecutorFilter={onClearExecutorFilter}
          deadlineFilter={deadlineFilter}
          setDeadlineFilter={setDeadlineFilter}
          onClearDeadlineFilter={onClearDeadlineFilter}
          filterFields={filterFields}
        />
        <div
          className={cn.notificationCenterList}
          ref={scrollRef}
          onScroll={(e: any) => onScroll(e.target.scrollTop)}
        >
          {notifications?.map((item) => (
            <NotificationItem
              key={item.id}
              notification={item}
              selectedNotifications={selectedNotifications}
              employees={employees}
              selectedNotificationId={selectedNotificationId}
              setSelectedNotification={setSelectedNotification}
              setSelectedNotifications={setSelectedNotifications}
            />
          ))}
          {!notifications?.length && !isLoading && !isFetching && (
            <div className={cn.emptyNotifications}>No notifications yet</div>
          )}
          {nextPageIsLoading && (
            <div className={cn.nextPageLoader}>
              <IconLoader />
            </div>
          )}
          {isFetching && !nextPageIsLoading && (
            <div className={cn.fetchingLoader}>
              <IconLoader />
            </div>
          )}
        </div>
      </>
    );
  }

  return (
    <div className={cn.notificationCenterColumn}>
      <div className={cn.notificationCenterColumnTop}>Notification center</div>
      {content}
    </div>
  );
};

export default NotificationCenterMainColumn;
